export const LocationDetailsTabs = {
    Null: null,
    Hours: 'hours',
    Fitting: 'fitting',
    Features: 'features',
}
